import styled from 'styled-components'

export const TabsHeader = styled.div`
  display: flex;
  gap: 24px;
  padding: 8px 0 0 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background.primary};
  position: sticky;
  top: 0;
  z-index: 1000;
`

export const TabButton = styled.button<{ $active: boolean }>`
  padding: 16px 8px;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.text.primary : theme.colors.text.secondary};
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 3px;
    transform: scaleX(${({ $active }) => ($active ? 1 : 0)});
    transform-origin: center;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primary};

    &::after {
      transform: scaleX(${({ $active }) => ($active ? 1 : 0.5)});
    }
  }

  svg {
    width: 16px;
    height: 16px;
  }
`
